module.exports = __webpack_public_path__ + "static/media/scan_0004.06b82c4b.jpg";